import { FC, useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { QuizQuestionForm } from './QuizQuestionForm';
import { LessonFormData, QuizQuestion } from './types';

interface QuizSectionProps {
  form: UseFormReturn<LessonFormData>;
  questions: QuizQuestion[];
  setQuestions: (questions: QuizQuestion[]) => void;
}

export const QuizSection: FC<QuizSectionProps> = ({ form, questions, setQuestions }) => {
  const TOTAL_QUESTIONS = 10;
  const POINTS_PER_QUESTION = 10;

  // Inicializar o completar las preguntas si es necesario
  useEffect(() => {
    console.log('QuizSection - Preguntas actuales:', questions);
    
    // Si hay preguntas existentes, completar hasta TOTAL_QUESTIONS
    if (questions.length > 0 && questions.length < TOTAL_QUESTIONS) {
      const remainingQuestions = Array(TOTAL_QUESTIONS - questions.length)
        .fill(null)
        .map(() => ({
          question: '',
          correct_answer: '',
          wrong_answers: ['', '', ''],
          points: POINTS_PER_QUESTION
        }));
      
      const updatedQuestions = [...questions, ...remainingQuestions];
      console.log('QuizSection - Completando preguntas existentes:', updatedQuestions);
      setQuestions(updatedQuestions);
      form.setValue('quiz_questions', updatedQuestions);
    }
    // Si no hay preguntas, inicializar todas
    else if (questions.length === 0) {
      const initialQuestions = Array(TOTAL_QUESTIONS)
        .fill(null)
        .map(() => ({
          question: '',
          correct_answer: '',
          wrong_answers: ['', '', ''],
          points: POINTS_PER_QUESTION
        }));
      
      console.log('QuizSection - Inicializando preguntas nuevas:', initialQuestions);
      setQuestions(initialQuestions);
      form.setValue('quiz_questions', initialQuestions);
    }
  }, [questions.length]);

  const updateQuestion = (index: number, updatedQuestion: QuizQuestion) => {
    console.log('QuizSection - Actualizando pregunta:', {
      index,
      updatedQuestion
    });

    const updatedQuestions = [...questions];
    updatedQuestions[index] = {
      ...updatedQuestion,
      points: POINTS_PER_QUESTION
    };
    setQuestions(updatedQuestions);
    form.setValue('quiz_questions', updatedQuestions);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Preguntas del Quiz</h3>
        <span className="text-sm text-gray-500">
          Completa las {TOTAL_QUESTIONS} preguntas del quiz
        </span>
      </div>

      <div className="space-y-6">
        {questions.map((question, index) => (
          <QuizQuestionForm
            key={index}
            question={question}
            onUpdate={(updatedQuestion) => updateQuestion(index, updatedQuestion)}
            questionNumber={index + 1}
          />
        ))}
      </div>
    </div>
  );
};